
let _baidu = {

    //加载基础代码
    load: function(){
        let js = 'window._agl = window._agl || [];\n' +
            '    (function () {\n' +
            '        _agl.push(\n' +
            '            [\'production\', \'_f7L2XwGXjyszb4d1e2oxPybgD\']\n' +
            '        );\n' +
            '        (function () {\n' +
            '            var agl = document.createElement(\'script\');\n' +
            '            agl.type = \'text/javascript\';\n' +
            '            agl.async = true;\n' +
            '            agl.src = \'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD\';\n' +
            '            var s = document.getElementsByTagName(\'script\')[0];\n' +
            '            s.parentNode.insertBefore(agl, s);\n' +
            '        })();\n' +
            '    })();';

        let _head = document.getElementsByTagName("head")[0];
        let script = document.createElement("script");
        script.append(js);
        _head.appendChild(script);
    },

    //加载事件代码
    submit: function () {
        try {
            console.log('百度监测')
            window._agl && window._agl.push(['track', ['success', {t: 3}]])
        } catch (e) {
            console.log(e)
        }
    },
};

export default _baidu
